import AppConstants from '../constants/AppConstants';
import store from '../stores/redux';
import api from '../api';
import handleError from '../helpers/requestErrorHandler';

const { dispatch } = store;
const defEvents = {
    before: AppConstants.REGIONS_START_LOADING,
    success: AppConstants.REGIONS_SEARCH_SUCCESS,
    fail: AppConstants.REGIONS_SEARCH_FAIL
};

const RegionsActions = {
    searchRegions(params, callback, events = defEvents) {
        dispatch({
            type  : events.before
        });

        api.searchRegions(params)
            .then(data => {
                dispatch({
                    type  : events.success,
                    items : data.response || {}
                });

                callback && callback();
            })
            .catch(err => {
                handleError(err, () => {
                    dispatch({
                        type: events.fail,
                        error: err
                    });
                });
            });
    },
};

export default RegionsActions;
